module.exports = __webpack_public_path__ + "static/media/singaporean.4d668372.png";